import { selectCountries } from "../../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../../components/enums";
import {
  ComplexFormSchemaComponents,
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { provinces } from "../../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../../store/HOC/genericUI.selectors";
import { peselMask, postalCodeMask } from "../../../../../utilities/masks";
import {
  selectShouldDisplayPerson,
  selectOwnerPersonFormData,
  selectUIData,
  selectOwnerAvailableCities,
} from "../owner.selectors";
import {
  setAvailableCities,
  setUIField,
  setUIObjectField,
} from "../owner.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.OWNER_PERSON_DATA,
  selector: selectOwnerPersonFormData,
  isVisible: selectShouldDisplayPerson,
  content: [
    {
      title: "Dane właściciela",
      sections: [
        {
          id: "person-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "person-data-2",
          wrapper: { xs: 6 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PESEL,
              label: "PESEL",
              mask: peselMask,
            },
          ],
        },
        {
          id: "person-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("personphone"),
              id: ComponentId.PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.EMAIL,
              label: "Email",
              required: true,
            },
          ],
        },
        {
          title: "Adres właściciela",
          id: "person-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET,
              label: "Ulica",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET_2,
              label: "Numer budynku / mieszkania",
              required: true,
            },
          ],
        },
        {
          id: "person-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "company[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "company[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "company[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectOwnerAvailableCities,
              required: true,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "company[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.CITY,
              label: "Miejscowość",
              required: true,
            },
          ],
        },
        {
          id: "person-data-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "person[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
};
